import { createAction, props } from '@ngrx/store';
import { UserAuthData } from './models/user-data.model';

export const userDataLoaded = createAction('[Common Auth] Load User Data', props<{ userData: UserAuthData }>());
